// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Vpg2","inner":"Footer_inner__36c6O","nextIcon":"Footer_nextIcon__3z0Oj","innerLeft":"Footer_innerLeft__20Eql"};